module.exports = __webpack_public_path__ + "static/img/212_TO8_2155_og.3b3ceb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/212_TO8_2155_og.jpg
// module id = V7Ut
// module chunks = 0